<div class="px-3 pt-3 flex-grow-1">
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center">
        <ng-container *ngIf="history.length > 1">
          <city-tax-back-link></city-tax-back-link>
        </ng-container>
        <span class="flex-grow-1 d-flex align-items-center">
          <h5 class="text-primary text-uppercase font-weight-bolder m-0">{{ title$ | async }}</h5>
        </span>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
